import { fillPlaceholders } from './fillPlaceholders';

interface Args {
  pair: string;
  values: Record<string, string>;
}

/**
 * `undefined` for a pair left without a value - a placeholder the form never
 * filled in is noise in the url, not an empty parameter.
 */
export const fillQueryPair = ({ pair, values }: Args): string | undefined => {
  const [key = '', ...valueParts] = pair.split('=');
  if (!valueParts.length) return pair;

  const value = fillPlaceholders({ template: valueParts.join('='), values });

  return value ? `${key}=${value}` : undefined;
};
